(() => {
  if (window.__loadMoreCollectionInit) return;
  window.__loadMoreCollectionInit = true;

  const SELECTORS = {
    grid: '.product-grid',
    paginationRow: '.pagination-row',
    loadMoreBtn: '[data-load-more]',
    ajaxContainer: '[data-ajax-container]'
  };

  let isLoading = false;
  let observer = null;
  let observerTimer = null;
  let activeController = null;

  function getGrid(root = document) {
    return root.querySelector(SELECTORS.grid);
  }

  function getPaginationRow(root = document) {
    return root.querySelector(SELECTORS.paginationRow);
  }

  function getButton(root = document) {
    return root.querySelector(SELECTORS.loadMoreBtn);
  }

  function getNextUrl(paginationRow) {
    if (!paginationRow) return null;

    const relNext = paginationRow.querySelector('a[rel="next"]');
    if (relNext?.href) return relNext.href;

    const nextByText = Array.from(paginationRow.querySelectorAll('a'))
      .find((a) => (a.textContent || '').trim().toLowerCase().includes('next') && a.href);

    return nextByText?.href || null;
  }

  function updateButtonState() {
    const btn = getButton();
    const paginationRow = getPaginationRow();
    if (!btn) return;

    const nextUrl = getNextUrl(paginationRow);

    if (nextUrl) {
      btn.style.display = '';
      btn.disabled = isLoading;
      btn.dataset.nextUrl = nextUrl;
    } else {
      btn.style.display = 'none';
      btn.disabled = true;
      btn.dataset.nextUrl = '';
    }

    if (!isLoading) {
      btn.textContent = 'Load more';
    }
  }

  function scheduleUpdateButtonState() {
    clearTimeout(observerTimer);
    observerTimer = setTimeout(updateButtonState, 100);
  }

  function disconnectObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function bindObserver() {
    disconnectObserver();

    const ajaxContainer = document.querySelector(SELECTORS.ajaxContainer);

    // Do not observe document.body. Too broad, too noisy.
    if (!ajaxContainer) return;

    observer = new MutationObserver(() => {
      scheduleUpdateButtonState();
    });

    observer.observe(ajaxContainer, {
      childList: true,
      subtree: true
    });
  }

  async function loadNextPage() {
    const btn = getButton();
    const grid = getGrid();
    const paginationRow = getPaginationRow();

    if (!btn || !grid || !paginationRow || isLoading) return;

    const nextUrl = btn.dataset.nextUrl?.trim();
    if (!nextUrl) {
      updateButtonState();
      return;
    }

    isLoading = true;
    btn.disabled = true;
    btn.textContent = 'Loading…';

    if (activeController) {
      activeController.abort();
    }
    activeController = new AbortController();

    try {
      const res = await fetch(nextUrl, {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        signal: activeController.signal
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const html = await res.text();
      if (!html) {
        throw new Error('Empty HTML response');
      }

      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = getGrid(doc);
      const newPaginationRow = getPaginationRow(doc);

      if (!newGrid) {
        throw new Error('Could not find product grid on next page');
      }

      const newItems = Array.from(newGrid.children);
      if (!newItems.length) {
        btn.dataset.nextUrl = '';
        updateButtonState();
        return;
      }

      const fragment = document.createDocumentFragment();
      newItems.forEach((el) => fragment.appendChild(el));
      grid.appendChild(fragment);

      if (newPaginationRow) {
        paginationRow.replaceWith(newPaginationRow);
      } else {
        btn.dataset.nextUrl = '';
      }

      updateButtonState();
    } catch (e) {
      if (e.name !== 'AbortError') {
        console.error('Load more collection failed:', e);
      }
    } finally {
      isLoading = false;
      activeController = null;

      const freshBtn = getButton();
      if (freshBtn) {
        freshBtn.disabled = false;
        freshBtn.textContent = 'Load more';
      }

      updateButtonState();
    }
  }

  function onClick(e) {
    const btn = e.target.closest(SELECTORS.loadMoreBtn);
    if (!btn) return;

    e.preventDefault();
    loadNextPage();
  }

  function init() {
    document.removeEventListener('click', onClick);
    document.addEventListener('click', onClick);

    bindObserver();
    updateButtonState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();